import { ColoursObj, Typography } from '@eventr/common-storybook'
import { Stack } from '@mui/material'
import { useShallow } from 'zustand/react/shallow'
import { useGuestStore } from '../../feat/guest/guest.store'
import i18n from '../../i18n/i18next'
import { useBoundStore } from '../../state/bound.store'
import { useRouteGuardContext } from '../../state/routeGuardProvider'
export const NoItinerariesContent = () => {
    const { isAllowed } = useRouteGuardContext()
    const { noItineraries } = useBoundStore(
        useShallow((s) => {
            return { noItineraries: s.noItineraries }
        })
    )
    const isGuestMode = useGuestStore((s) => s.isGuestMode)
    if (isGuestMode) return null
    function IsAdminUser() {
        return (
            <>
                {isAllowed(['allowedEdit']) && (
                    <Stack gap="8px">
                        <Typography
                            fontSize={'16px'}
                            variant="bodySubtext"
                            color={ColoursObj.shades.shade1}
                            id={
                                noItineraries
                                    ? 'readyToStartText'
                                    : 'addYourSelfText'
                            }
                            align="center"
                            lineHeight={'24px'}
                        >
                            {noItineraries
                                ? i18n.t('home.ready-to-start')
                                : i18n.t('home.add-yourself-to-activities')}
                        </Typography>
                    </Stack>
                )}
            </>
        )
    }
    function IsNotAdminUser() {
        return (
            <>
                {isAllowed(['allowedEdit']) ? (
                    <Stack gap="8px">
                        <Typography
                            fontSize={'16px'}
                            variant="bodySubtext"
                            color={ColoursObj.shades.shade1}
                            id={
                                noItineraries
                                    ? 'readyToStartText'
                                    : 'addYourSelfText'
                            }
                            align="center"
                            lineHeight={'24px'}
                        >
                            {noItineraries
                                ? i18n.t('home.ready-to-start')
                                : i18n.t('home.add-yourself-to-activities')}
                        </Typography>
                    </Stack>
                ) : (
                    <Stack gap="8px" alignItems={'center'}>
                        <Typography
                            color={ColoursObj.core.secondary}
                            id="contactAdminText"
                            align="center"
                        >
                            {i18n.t('home.get-in-touch-admin')}
                        </Typography>
                    </Stack>
                )}
            </>
        )
    }
    return (
        <>
            <Typography
                variant="bodyRegular"
                color={ColoursObj.shades.shade1}
                align="left"
            >
                {isAllowed(['checkAdmin']) ? (
                    <IsAdminUser />
                ) : (
                    <IsNotAdminUser />
                )}
            </Typography>
        </>
    )
}
